import { render, staticRenderFns } from "./addArea.vue?vue&type=template&id=9f6543a2&scoped=true"
import script from "./addArea.vue?vue&type=script&lang=js"
export * from "./addArea.vue?vue&type=script&lang=js"
import style0 from "./addArea.vue?vue&type=style&index=0&id=9f6543a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6543a2",
  null
  
)

export default component.exports